export default function Footer() {
  return (
    <footer
      className="bg-gray-800 text-white text-center py-4"
      style={{ position: "fixed", bottom: "0px", width: "100%" }}
    >
      &copy; {new Date().getFullYear()} SSP NextGen E-Bikes. All rights
      reserved.
    </footer>
  );
}
